import Button from '@doordash/component-button'
import {
  Text,
  InlineChildren,
  StackChildren,
  Inset,
} from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { FAST_PAY_SUB } from '../../../constants'
import { AlertWrapper } from './styles'

import routes from '../../../routes'

import { fastPay } from './strings'
import LinkButton from '../../atoms/link-button'

import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'

type ReduxProps = {
  application: any
  trackConfirmationPageClick?: (string) => Promise<any>
  trackFastPaySetup?: (data: DA.FastPaySetup) => Promise<any>
}

type Props = {
  skipStep: () => void
  isPaymentAccountSetup: boolean
}

const FastPayStep: React.FC<Props & ReduxProps> = ({
  skipStep,
  application,
  trackFastPaySetup,
  isPaymentAccountSetup,
}) => {
  const isWebview = detectWebviewOs() !== OsTypes.NONE

  const handleFastPayClicked = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    trackFastPaySetup({
      action: DA.EventActions.Clicked,
      name: DA.FastPayNames.FastPayOnboardingStart,
    })
  }

  const handleSkipClicked = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    trackFastPaySetup({
      action: DA.EventActions.Clicked,
      name: DA.FastPayNames.FastPayOnboardingSkip,
    })
    skipStep()
  }

  return (
    <StackChildren>
      <Text styles={Text.Styles.PageDescriptionBody}>
        {fastPay.description()}
      </Text>
      {isPaymentAccountSetup && (
        <InlineChildren>
          <LinkButton
            type={Button.Types.PrimaryPill}
            isInline
            size={Button.Sizes.Small}
            onClick={handleFastPayClicked}
            href={
              isWebview
                ? routes.webview.buildPath({ sub: FAST_PAY_SUB })
                : routes.fastPaySetup.buildPath({
                    uniqueLink: application.uniqueLink,
                  })
            }
          >
            {fastPay.primaryButton()}
          </LinkButton>

          <Button
            size={Button.Sizes.Small}
            type={Button.Types.TertiaryPill}
            onClick={handleSkipClicked}
            isInline
          >
            {fastPay.secondaryButton()}
          </Button>
        </InlineChildren>
      )}
      {!isPaymentAccountSetup && (
        <AlertWrapper>
          <Inset size={Inset.Sizes.XxSmall}>
            <Text>{fastPay.bankAccountAlert()}</Text>
          </Inset>
        </AlertWrapper>
      )}
    </StackChildren>
  )
}

const mapStateToProps = state => ({
  application: state.application,
})

const mapDispatchToProps = {
  trackConfirmationPageClick: events.trackConfirmationPageClick,
  trackFastPaySetup: events.trackFastPaySetup,
}

export default connect(mapStateToProps, mapDispatchToProps)(FastPayStep)
